import moment from 'moment';

export const formatDate = (dateToFormat, language, separator = '.') => {
  if (language === 'English') {
    return moment.unix(dateToFormat).format(`YYYY${separator}MM${separator}DD`);
  } else {
    return moment.unix(dateToFormat).format(`DD${separator}MM${separator}YYYY`);
  }
};
